module.exports = __webpack_public_path__ + "img/shitucheng.e109e7eb.png";